// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bz2Z","col":"styles_col__3qEFu"};